import { createLogger } from 'redux-logger'
import thunkMiddleware from 'redux-thunk'
import { createStore, compose, applyMiddleware } from 'redux'
import rootReducer from './reducers/index'
import adsRefresh from './middleware/adsMiddleware'
import videoMiddle from './middleware/videoMiddleware'

let middleware = [thunkMiddleware, adsRefresh, videoMiddle]
let composeEnhancers = compose

if (process.env.REACT_APP_ENV !== 'production') {
    const loggerMiddleware = createLogger()
    middleware = applyMiddleware(...middleware, loggerMiddleware)
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
} else {
    middleware = applyMiddleware(...middleware)
}

const store = createStore(rootReducer, composeEnhancers(middleware))

// make store available from console
if (process.env.REACT_APP_ENV !== 'production') {
    window.store = store
}

export default store
